import React from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';

export interface LogikMuiThemeProps {
    children: React.ReactNode;
}
//Change various sizes here so the theme can use the font sizes for various things.
const baseTheme = createTheme();

let theme = createTheme({
    palette: {
        primary: {
            main: '#6185C4',
        },
        secondary: {
            main: '#5a6268',
        },
        warning: {
            main: '#ff9800',
        },
        success: {
            main: '#4caf50',
        },
        info: {
            main: '#2196f3',
        },
        text: {
            primary: '#212529',
        },
    },
    typography: {
        h1: {
            fontWeight: 400,
        },
        h2: {
            fontWeight: 400,
        },
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                container: {
                    alignItems: 'stretch',
                },
                'direction-xs-column': {
                    paddingRight: baseTheme.spacing(1),
                    paddingLeft: baseTheme.spacing(1),
                },
                'direction-xs-column-reverse': {
                    paddingRight: baseTheme.spacing(1),
                    paddingLeft: baseTheme.spacing(1),
                },
            },
            defaultProps: {
                spacing: 1,
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    height: '100%',
                    marginBottom: baseTheme.spacing(2),
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    background: 'rgba(0,0,0,.03)',
                    boxShadow: 'inherit',
                },
            },
            defaultProps: {
                titleTypographyProps: {variant: 'h6'},
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    overflowX: 'auto',
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    justifyContent: 'flex-end',
                },
            },
        },
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl',
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                size: 'small',
                fullWidth: true,
                notched: false,
                label: '',
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:focus': {
                        outline: '0',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: '#0b3355',
                    '& img': {
                        maxHeight: '3rem',
                    },
                    paddingTop: baseTheme.spacing(2),
                    paddingBottom: baseTheme.spacing(2),
                    marginBottom: baseTheme.spacing(2),
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: 'unset',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:nth-of-type(odd)': {
                        backgroundColor: 'rgba(0,0,0,.05)',
                    },
                    // hide last border
                    '&:last-child td, &:last-child th': {
                        border: 0,
                    },
                },
                head: {
                    backgroundColor: 'inherit!important',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 'bold',
                },
            },
        },
    },
});

const LogikMuiTheme = ({children}: LogikMuiThemeProps) => (
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default LogikMuiTheme;
